import React, { useEffect, useState } from 'react'
import { SettingsMainContainer, SettingsViewContainer } from '../settings.styled'
import styled from 'styled-components'
import Toggle from 'react-toggle'
import "react-toggle/style.css" // for ES6 modules
import { getSettings, setSettings, updateSettings, resetSettings, setTestSettings } from 'features/profileChurch/profileChurchSlice'
import { settingsStore } from 'app/settingsStore'
import { useSelector, useDispatch } from 'react-redux'
import { SettingsMainBtn, SettingsMainBtnCancel } from '../settings.styled'
import { SDesc, SettingsBtnWrap, SettingsInfo, SettingsItem, ProfileSettingsContainer, SettingsItemWrap, SettingsNameWrap, SettingsName, ToggleButtonWrap } from './profileSettings.styled'
import Loader from 'loaders/Loader' 
import SettingsMenuItem from './SettingMenuItem'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

export default function ProfileFeatureSettings() {
    const { t } = useTranslation('settings')
    const dispatch = useDispatch()  
    const { 
        features,
        arePublicSettingsSaved,
        areFeaturesEdited,
        areFeaturesSaved,
        isChurchSettingsLoading,
        isChurchSettingUpdating, 
        isChurchSettingsSuccess 
    } = useSelector((state) => state.profileChurch)


    const handleToggleChange = (event) => { 
        // dispatch(setSettings({
        //     settingType: 'features',
        //     name: event,
        //     value: !features[event]
        // }))
    }
 
    const { isEdited, settingsInfo, setIsEdited } = settingsStore() 



    useEffect(() => { 
        dispatch(getSettings({
            settingType: 'features' 
        }))  
    }, [])

    useEffect(() => {
        if(areFeaturesSaved){

            toast.success(t('visibility.updated'))
        }
    }, [areFeaturesSaved])
         

    const handleSubmit = () => { 
      dispatch(updateSettings({
            settingType: 'features', 
            settings: features
      })) 
    }

    const handleCancel = () => { 
      setIsEdited(false) 
      dispatch(resetSettings())
    }


    return (
        <SettingsViewContainer>
            <SDesc>{t('visibility.featureHelp')}</SDesc>
            <ProfileSettingsContainer> 
                {
                    (isChurchSettingsLoading || isChurchSettingUpdating) && 
                    (  
                        <div style={{ 
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}> 
                            <Loader /> 
                        </div>
                    )
                }
                <SettingsItemWrap> 
                { 
                    isChurchSettingsSuccess &&
                    (
                        features.main.map((setting, index) => {
                            return (
                                <SettingsMenuItem 
                                    key={setting.value}
                                    index={index}
                                    setting={setting}
                                    location={'main'}
                                    />
                            )
                        })
                    ) 
                }

                <ExtraItems>
                    <span>{t('visibility.dropdownHelp')}</span>

                    { 
                        isChurchSettingsSuccess &&
                        (
                            features.extra.map((setting, index) => {
                                return (
                                    <SettingsMenuItem 
                                        key={setting.value}
                                        index={index}
                                        setting={setting}
                                        location={'extra'}
                                        /> 
                                )
                            }) 
                        )
                    }
 
                </ExtraItems>

                </SettingsItemWrap>  
                { areFeaturesEdited && (
                    <SettingsBtnWrap>
                        <SettingsMainBtnCancel
                            disabled={isChurchSettingUpdating}
                            onClick={handleCancel}
                            >{t('visibility.cancel')}
                        </SettingsMainBtnCancel> 
                        <SettingsMainBtn
                            disabled={isChurchSettingUpdating}
                            onClick={handleSubmit}
                            >{t('visibility.save')}
                        </SettingsMainBtn>
                    </SettingsBtnWrap>
                )}
            </ProfileSettingsContainer>   
        </SettingsViewContainer>
    )
}


const ExtraItems = styled.div`
    width: 100%;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

`
